// extracted by mini-css-extract-plugin
export default {"block":"HighlightSlide_block__jNZMf","img":"HighlightSlide_img__eIR3-","title":"HighlightSlide_title__9ojA7","description":"HighlightSlide_description__+bw6F"};